import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-10 items-center rounded-[111px] px-4 transition-opacity duration-200'
  },
  variants: {
    isLoaded: {
      true: 'bg-blue-light opacity-100',
      false: 'opacity-0'
    }
  },
  defaultVariants: {
    isLoaded: false
  }
});
